import React, { useState, useEffect } from "react";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Row, Col, Form, Input, Button, Space, Modal, Checkbox, Upload, message } from 'antd';
import ValidatorHelpers from '../../helpers/ValidatorHelper';
import axios from 'axios';
import config from '../../../config';
import { usePersistedStore } from "../../../store/persisted-store";

const EditSlide = (props) => {
    const { auth, business } = usePersistedStore();
    const [editForm] = Form.useForm();
    const { selectedSlide, editModal, closeModal } = props;
    const [states, setStates] = useState({
        desktopLoading: false,
        tabletLoading: false,
        mobileLoading: false,
        desktopFile: false,
        tabletFile: false,
        mobileFile: false,
        desktopStatus: false,
        tabletStatus: false,
        mobileStatus: false,
        submitLoading: false
    });

    useEffect(() => {
        if (selectedSlide) {
            setStates({
                ...states,
                desktopStatus: selectedSlide.EnableDesktop,
                tabletStatus: selectedSlide.EnableTablet,
                mobileStatus: selectedSlide.EnableMobile
            })
        }
    }, [])

    const businessToken = business.currentBusiness.token;
    const userToken = auth.userToken;

    const beforeUpload = (file) => {
        const isLt2M = file.size / 1024 < 1000;
        if (!isLt2M) {
            message.error("محدودیت حجم فایل ۱ مگابایت است.");
            return false;
        }
        switch (file.type) {
            case "image/jpeg":
                return true;
            case "image/webp":
                return true;
            default:
                message.error("نوع فایل انتخابی صحیح نمی باشد.");
                return false;
        }
    }

    const handleChange = (info, type) => {
        const { status } = info.file;
        if (status === 'uploading') {
            type === 'desktop' && setStates({ ...states, desktopLoading: true });
            type === 'tablet' && setStates({ ...states, tabletLoading: true });
            type === 'mobile' && setStates({ ...states, mobileFile: true });
            return
        }

        if (status === 'done') {
            type === 'desktop' && setStates({ ...states, desktopLoading: false, desktopFile: info.file.response });
            type === 'tablet' && setStates({ ...states, tabletLoading: false, tabletFile: info.file.response });
            type === 'mobile' && setStates({ ...states, mobileFile: false, mobileFile: info.file.response });


        } else if (status === 'error') {
            type === 'desktop' && setStates({ ...states, desktopLoading: false });
            type === 'tablet' && setStates({ ...states, tabletLoading: false });
            type === 'mobile' && setStates({ ...states, mobileFile: false });

            if (info.file.error.status >= 400 && info.file.error.status <= 499) {
                message.error(info.file.response.Message, info.file.error.status);
            }
            else {
                message.error(`خطا در بارگذاری تصویر`);
            }
        }
    };

    const onFinish = (values) => {
        setStates({ ...states, submitLoading: true })
        const data = {
            Id: selectedSlide.Id,
            EnableDesktop: states.desktopStatus,
            EnableTablet: states.tabletStatus,
            EnableMobile: states.mobileStatus,
            DesktopClientId: values.DesktopClientId,
            TabletClientId: values.TabletClientId,
            MobileClientId: values.MobileClientId,
            Title: values.Title,
            Link: values.Link,
            FileName: values.FileName,
            Order: values.Order
        }
        axios({
            method: "put",
            baseURL: config.apiUrls(),
            url: `/v1/business/Slider`,
            headers: { Authorization: `Bearer ${userToken}`, "token": businessToken },
            data: data
        }).then((res) => {
            setStates({ ...states, submitLoading: false })
            res && closeModal()
        }).catch((error) => {
            message.error(error)
            setStates({ ...states, submitLoading: false })
        })
    }

    const onFinishFailed = (errorInfo) => {
        editForm.scrollToField(errorInfo.errorFields[0].name, {
            scroll: {
                offsetTop: 65,
            }
        });
    }

    return (<>
        <Modal
            width={800}
            className="custom-table"
            title="ویرایش اسلایدر"
            visible={editModal}
            footer={false}
            onCancel={() => { closeModal() }}>
            <Form form={editForm} colon="false" initialValues={selectedSlide} onFinish={onFinish} onFinishFailed={onFinishFailed} layout="vertical">
                <Row justify="space-between" gutter={16} align="middle">
                    <Col span={12}>
                        <Form.Item
                            name="Title"
                            rules={ValidatorHelpers.required("عنوان")}
                            label="عنوان">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="FileName"
                            rules={ValidatorHelpers.required("نام فایل")}
                            label="نام فایل">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={20}>
                        <Form.Item
                            name="Link"
                            rules={ValidatorHelpers.required("لینک")}
                            label="لینک">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="Order"
                            rules={ValidatorHelpers.required("ترتیب")}
                            label="ترتیب">
                            <Input type="tel" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="EnableDesktop" className="text-center">
                            <Checkbox defaultChecked={selectedSlide?.EnableDesktop} onChange={(e) => setStates({ ...states, desktopStatus: e.target.checked })} />
                            <span style={{ paddingRight: '10px' }}>وضعیت در دسکتاپ</span>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="EnableTablet" className="text-center">
                            <Checkbox defaultChecked={selectedSlide?.EnableTablet} onChange={(e) => setStates({ ...states, tabletStatus: e.target.checked })} />
                            <span style={{ paddingRight: '10px' }}>وضعیت در تبلت</span>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="EnableMobile" className="text-center">
                            <Checkbox defaultChecked={selectedSlide?.EnableMobile} onChange={(e) => setStates({ ...states, mobileStatus: e.target.checked })} />
                            <span style={{ paddingRight: '10px' }}>وضعیت در موبایل</span>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item wrapperCol={{ align: "center" }} span={24}>
                            <Button type="primary" htmlType="submit" loading={states.submitLoading}> ثبت تغییرات </Button>
                        </Form.Item>
                    </Col>
                    <Col span={8}>

                        <Form.Item
                            className="text-center"
                            name="DesktopAddress"
                            label="دسکتاپ">
                            <Space direction="vertical" style={{ width: '100%' }} size="large">
                                <Upload
                                    name={selectedSlide?.FileName}
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action={`${config.apiUrls()}/v1/business/Slider-Image`}
                                    headers={{
                                        Token: businessToken,
                                        authorization: `Bearer ${userToken}`
                                    }}
                                    data={{ "type": "desktop", "id": selectedSlide?.Id }}
                                    beforeUpload={beforeUpload}
                                    onChange={file => handleChange(file, "desktop")}
                                >
                                    {(selectedSlide?.DesktopAddress && !states.desktopFile) ? <img src={selectedSlide?.DesktopAddress} alt="" style={{ width: '100%' }} /> :

                                        states.desktopFile ? <img src={states.desktopFile} alt="" style={{ width: '100%' }} /> :
                                            <div>
                                                {states.desktopLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                                <div style={{ marginTop: 8 }}>بارگذاری فایل</div>
                                            </div>}
                                </Upload>
                            </Space>
                        </Form.Item>

                    </Col>
                    <Col span={8}>
                        <Form.Item
                            className="text-center"
                            name="TabletAddress"
                            label="تبلت">
                            <Space direction="vertical" style={{ width: '100%' }} size="large">
                                <Upload
                                    name={selectedSlide?.FileName}
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action={`${config.apiUrls()}/v1/business/Slider-Image`}
                                    headers={{
                                        Token: businessToken,
                                        authorization: `Bearer ${userToken}`
                                    }}
                                    data={{ "type": "tablet", "id": selectedSlide?.Id }}
                                    beforeUpload={beforeUpload}
                                    onChange={file => handleChange(file, "tablet")}
                                >
                                    {(selectedSlide?.TabletAddress && !states.tabletFile) ? <img src={selectedSlide?.TabletAddress} alt="" style={{ width: '100%' }} /> :
                                        states.tabletFile ? <img src={states.tabletFile} alt="" style={{ width: '100%' }} /> :
                                            <div>
                                                {states.tabletLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                                <div style={{ marginTop: 8 }}>بارگذاری فایل</div>
                                            </div>}
                                </Upload>
                            </Space>
                        </Form.Item>

                    </Col>
                    <Col span={8}>
                        <Form.Item
                            className="text-center"
                            name="MobileAddress"
                            label="موبایل">
                            <Space direction="vertical" style={{ width: '100%' }} size="large">
                                <Upload
                                    name={selectedSlide?.FileName}
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action={`${config.apiUrls()}/v1/business/Slider-Image`}
                                    headers={{
                                        Token: businessToken,
                                        authorization: `Bearer ${userToken}`
                                    }}
                                    data={{ "type": "mobile", "id": selectedSlide?.Id }}
                                    beforeUpload={beforeUpload}
                                    onChange={file => handleChange(file, "mobile")}
                                >
                                    {(selectedSlide?.MobileAddress && !states.mobileFile) ? <img src={selectedSlide?.MobileAddress} alt="" style={{ width: '100%' }} /> :
                                        states.mobileFile ? <img src={states.mobileFile} alt="" style={{ width: '100%' }} /> :
                                            <div>
                                                {states.mobileLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                                <div style={{ marginTop: 8 }}>بارگذاری فایل</div>
                                            </div>}
                                </Upload>
                            </Space>

                        </Form.Item>
                    </Col>
                    <Col span={8} className="text-center">
                        <Form.Item
                            name="DesktopClientId"
                            label="desktop-client-id">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8} className="text-center">
                        <Form.Item
                            name="TabletClientId"
                            label="tablet-client-id">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8} className="text-center">
                        <Form.Item
                            name="MobileClientId"
                            label="mobile-client-id">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </>)
}

export default EditSlide